import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Predicates } from '../validation'
import { AddExclusionButton } from '../../../components/application-exclusions/add-exclusion-button'
import { RouteContext } from '../../../components/route-provider'
import { getApplicationDrilldownID } from '../../../components/route'
import { AttackEventForExclusion } from '../../../components/application-exclusions/shared'

const directiveName = 'reactAddExclusionButton'

interface BridgeProps {
  isRaspEnabled: boolean
  organizationUuid: string
  successCallback: (exclusionId: string, shouldSuppressEvents: boolean) => void
  eventForExclusion?: AttackEventForExclusion
}

export function Bridge({
  isRaspEnabled,
  organizationUuid,
  successCallback,
  eventForExclusion
}: BridgeProps) {
  const isApiValid = isValid({
    eventForExclusion,
    isRaspEnabled,
    organizationUuid,
    successCallback
  })

  if (!isApiValid) {
    console.error(`invalid props for ${directiveName}`)
    return <></>
  }

  return (
    <RouteContext.Consumer>
      {({ parameters }) => {
        const appID = getApplicationDrilldownID(parameters)

        if (!appID) {
          throw new Error('Unable to parse application ID from route')
        }

        return (
          <AddExclusionButton
            applicationId={appID}
            isRASPEnabled={isRaspEnabled}
            organizationUuid={organizationUuid}
            successCallback={successCallback}
            eventForExclusion={eventForExclusion}
          />
        )
      }}
    </RouteContext.Consumer>
  )
}

export const reactAddExclusionButton = createNgReactBridgeDirective(
  directiveName,
  [],
  Bridge,
  ['isRaspEnabled', 'organizationUuid', 'successCallback', 'eventForExclusion']
)

function isValid({
  isRaspEnabled,
  organizationUuid,
  successCallback,
  eventForExclusion
}) {
  return (
    (eventForExclusion === undefined ||
      Predicates.isObject(eventForExclusion)) &&
    Predicates.isBoolean(isRaspEnabled) &&
    Predicates.isString(organizationUuid) &&
    typeof successCallback === 'function'
  )
}
